module.exports = __webpack_public_path__ + "img/cat-body.e63f7dfd.png";